<template lang="pug">
.numpad
    .numpad-grid
        template(v-for="button in buttons")
            button(
                type="button"
                :key="button.value"
                :class="button.class"
                :style="[{ 'grid-row': button.row, 'grid-column': button.column }, button.style]"
                :data-row="button.row"
                :data-column="button.column"
                :disabled="isDisabled(button)"
                @mousedown.prevent.stop="handleClick(button, $event)"
                tabindex="-1"
            )
                | {{ button.label || button.value }}
</template>

<script>
export default {
    name: 'NumPad',
    props: {
        value: {
            default: undefined
        },
        type: {
            type: String,
            default: 'string',
            validator(value) {
                // The value must match one of these strings
                return ['string', 'float'].includes(value)
            }
        },
        decimalSeparator: {
            type: String,
            default: '.',
            validator(value) {
                // The value must match one of these strings
                return ['.', ','].includes(value)
            }
        },
        thousandsSeparator: {
            type: String,
            default: ',',
            validator(value) {
                // The value must match one of these strings
                return ['.', ','].includes(value)
            }
        },
        precision: {
            type: Number,
            default: 2,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        preventDefault: {
            type: Boolean,
            default: false
        },
        buttons: {
            type: Array,
            default() {
                return [
                    { value: 1, row: 4, column: 1, class: 'numpad-button-1' },
                    { value: 2, row: 4, column: 2, class: 'numpad-button-2' },
                    { value: 3, row: 4, column: 3, class: 'numpad-button-3' },
                    { value: 4, row: 3, column: 1, class: 'numpad-button-4' },
                    { value: 5, row: 3, column: 2, class: 'numpad-button-5' },
                    { value: 6, row: 3, column: 3, class: 'numpad-button-6' },
                    { value: 7, row: 2, column: 1, class: 'numpad-button-7' },
                    { value: 8, row: 2, column: 2, class: 'numpad-button-8' },
                    { value: 9, row: 2, column: 3, class: 'numpad-button-9' },
                    { value: 0, row: 5, column: '1/3', class: 'numpad-button-0' },
                    { value: 'decimal-separator', label: this.decimalSeparator, row: 5, column: 3, class: 'numpad-button-decimal' },
                    { value: 'clear', label: 'C', row: 1, column: 1, class: 'numpad-button-clear' },
                    { value: 'backspace', label: '⟵', row: 1, column: '2/4', class: 'numpad-button-backspace' },
                ]
            }
        }
    },
    data() {
        // let content = this.value || ''
        // if (typeof content === 'number') content = content.toString()
        return {
            content: '',
        }
    },
    watch: {
        value(value) {
            this.formatContent(value)
        },
        content(content) {
            this.$emit('update', content.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator) || '0')
        }
    },
    methods: {
        formatContent(value) {
            let content = value || ''
            if (typeof content === 'number') {
                content = content.toString()
                if (this.decimalSeparator !== '.') content = content.replace('.', this.decimalSeparator)
            }
            this.content = content
        },
        isDisabled(button) {
            let disabled = this.disabled
            // if (! disabled && button.value === 'decimal-separator' && this.content.includes(this.decimalSeparator)) {
            //     disabled = true
            // }
            if (! disabled
                && ! ['clear', 'backspace'].includes(button.value)
                && this.content.includes(this.decimalSeparator)
                && this.content.length - this.content.indexOf(this.decimalSeparator) > this.precision) {
                disabled = true
            }
            return disabled
        },
        handleClick(button, event) {

            event.target.blur()
            if (this.preventDefault) event.preventDefault()

            if (typeof button.onclick === 'function') {
                // TODO
            } else {
                switch (button.value) {
                    case 'clear':
                        this.content = '';
                        break;

                    case 'backspace':
                        this.content = this.content.slice(0, this.content.length - 1)
                        break;

                    case 'decimal-separator':
                        if (! this.content.includes(this.decimalSeparator)) {
                            if (! this.content) this.content = '0'
                            this.content += this.decimalSeparator
                        }
                        break;

                    default:
                        if (! this.content.includes(this.decimalSeparator)
                            || this.content.length - this.content.indexOf(this.decimalSeparator) <= this.precision) {
                            this.content += button.value
                            if (button.value == 0 && this.content.length === 1) {
                                this.content += this.decimalSeparator
                            }
                        }
                        break;
                }

                let value = this.content
                if (this.type === 'float') {
                    if (value) value = parseFloat(value.replace(',', '.'))
                    else value = 0
                }
                this.$emit('input', value)
            }
        }
    },
    mounted() {
        if (this.value) {
            this.formatContent(this.value)
        }
    }
};
</script>

<style lang="sass" scoped>
.numpad-grid
    display: grid
    grid-auto-flow: row dense
    grid-template-rows: repeat(5, 52px)
    grid-template-columns: repeat(3, 1fr)
    gap: 2px
    min-width: 160px
    max-width: 316px
button
    color: #888
    background: #F5F7FA
    // border: 0.004rem solid #F5F7FA
    border: none
    font-size: 1rem
    font-weight: bold
    cursor: pointer
    transition: background .15s ease
    border-radius: 4px
    // height: 50px
    &[disabled="disabled"]
        // opacity: 0.8
        color: #C0C4CC
        cursor: not-allowed
    &:not([disabled="disabled"])
        &:hover, &:focus
            background: #EDEFF3
    &.numpad-button-clear
        background: #F56C6C
        color: #FFF
        &:not([disabled="disabled"])
            &:hover, &:focus
                background: darken(#F56C6C, 5%)
        &[disabled="disabled"]
            background: lighten(#F56C6C, 10%)
</style>
